$(document).ready(function() {
  const quizChapterEnabledCheckboxId        = "chapter_quiz";
  const newQuizChapterTimeLimitPerPageClass = "new-quiz-chapter-settings-time-limit-per-page";
  const quizChapterEnabledCheckbox          = $(`#${quizChapterEnabledCheckboxId}`);
  const newQuizChapterTimeLimitPerPage      = $(`.${newQuizChapterTimeLimitPerPageClass}`);

  if (quizChapterEnabledCheckbox && newQuizChapterTimeLimitPerPage) {
    quizChapterEnabledCheckbox.on("click", function(event) {
      newQuizChapterTimeLimitPerPage.toggle();
    });
  }
  else {
    // No quiz chapter checkbox or quiz chapter time limit per page available
  }
});
